/**
 * The consent wordings SHOWN to the user, keyed by the version recorded
 * with the consent (§9.3). These must match `apps/api/src/consent.ts`
 * exactly — displaying one wording while recording another version would
 * make the consent record unreconstructable, which is the whole point of
 * versioning it. `apps/api/test/consent-parity.test.ts` compares the two
 * files and fails the build on drift.
 */
export const CONSENT_WORDINGS: Record<string, string> = {
  "save-result-v1":
    "Save this result — We'll email you a copy, and if the £29,000 threshold changes we'll tell you what it means for your figures. First name and email — nothing else.",
  "result-by-email-v1":
    "Send my result by email — We'll email you a copy of your result when it is ready, and if the £29,000 threshold changes we'll tell you what it means for your figures. First name and email — nothing else, and you can stop the emails with one click.",
  "subscribe-v1":
    "We'll email you when the rules or fees behind your figures change. Nothing else, and you can stop it with one click.",
  "share-partner-v1":
    "Send this to your partner — We'll email the same copy of this result to you and to your partner, including the figures you entered. We do not keep your partner's email address.",
  // v1 is left exactly as it was and is still accepted for records written
  // under it. Those people were told we keep nothing, and that promise is not
  // retroactively editable — which is the whole reason wordings are versioned.
  "share-partner-v2":
    "Send this to your partner — We'll email the same copy of this result to you and to your partner, including the figures you entered. We keep their address as part of your record, and their copy tells them so and how to stop any further emails.",
};
